import * as React from 'react';
import { ProgressCircle as SpinnerDeterminate } from './ProgressCircle';
import { Spinner as InfinityCircle } from './Spinner';
export var ProgressCircle = _ref => {
  var {
    progress = -1,
    accessibilityMessage,
    size,
    className
  } = _ref;
  return progress >= 0 ? /*#__PURE__*/React.createElement(SpinnerDeterminate, {
    progress: progress,
    size: size,
    className: className
  }) : /*#__PURE__*/React.createElement(InfinityCircle, {
    accessibilityMessage: accessibilityMessage,
    size: size,
    className: className
  });
};
//# sourceMappingURL=ProgressCircleComponent.js.map